import { Button } from "rsuite";
import styles from "./AttachedFilesBlock.module.css";
import {
  formatDate,
  isCertFilesAllowedAddDelete,
} from "../../../../helperFunctions";
import { Divider, Popover, Whisper } from "rsuite";
import { useEffect, useState } from "react";
import FileUploaderModal from "./Components/FileUploaderModal/FileUploaderModal";
import { useFileUploaderModal } from "./Components/FileUploaderModal/useFileUploaderModal";
import FilePreviewModal from "./Components/FilePreviewModal/FilePreviewModal";
import { useFilePreviewModal } from "./Components/FilePreviewModal/useFilePreviewModal";
import AttachmentIcon from "@rsuite/icons/Attachment";
import VisibleIcon from "@rsuite/icons/Visible";
import { useCertificates } from "../../useCertificates";
import { SlCloudDownload } from "react-icons/sl";
import { LiaFileDownloadSolid } from "react-icons/lia";
import { RiMessage2Line } from "react-icons/ri";
import moment from "moment";

const formatLogTime = (time) => {
  if (!time) return "---";

  const parsed = moment(
    time,
    [
      "DD/MM/YYYY HH:mm",
      "YYYY-MM-DD HH:mm",
      "YYYY-MM-DD HH:mm:ss",
      moment.ISO_8601,
    ],
    true,
  );
  if (parsed.isValid()) return parsed.format("YYYY-MM-DD HH:mm");

  const fallback = moment(time);
  return fallback.isValid()
    ? fallback.format("YYYY-MM-DD HH:mm")
    : String(time);
};

function AttachedFilesBlock({ inputsStatus, locationId }) {
  const { showFileUploaderModal } = useFileUploaderModal();
  const { form, filesData } = useCertificates.getState();
  const { deleteAttachedFile, loading, getAttachedFilesData } =
    useCertificates();

  useEffect(() => {
    getAttachedFilesData();
  }, [form.attachedFiles]);

  const addFilesButton = (
    <Button
      disabled={inputsStatus == "readonly" ? true : false}
      onClick={showFileUploaderModal}
      color="blue"
      appearance="primary"
      style={{ width: 100 }}
    >
      Add files
    </Button>
  );

  const showCertFilesButton = isCertFilesAllowedAddDelete(form.status);

  return (
    <>
      <div className={styles.container}>
        <Divider />
        <div className={styles.header}>
          <div className={styles.title}>
            Certificate files
            {filesData.length > 0 && (
              <span className={styles.count_badge}>{filesData.length}</span>
            )}
          </div>
          {showCertFilesButton && locationId && addFilesButton}
        </div>
        <div className={styles.attached_files_container}>
          {filesData.length != 0 && (
            <div className={styles.titles}>
              <div>File Name</div>
              <div>Date added</div>
              <div>Local Status</div>
              <div>Cloud file</div>
              <div>File Origin</div>
              <div>Logs</div>
              <div>Delete</div>
            </div>
          )}

          {filesData.length != 0 &&
            filesData.map((fileData, index) => (
              <File
                key={fileData?._id || index}
                inputsStatus={inputsStatus}
                fileData={fileData}
                onDelete={() => {
                  deleteAttachedFile(fileData?._id);
                }}
              />
            ))}

          {filesData.length === 0 && (
            <div className={styles.empty_state}>No certificate files yet</div>
          )}

          <Divider />

          {/* {filesData.length != 0 && (
            <FilesBlock filesData={filesData} onDelete={deleteAttachedFile} />
          )} */}
        </div>
      </div>
      <FileUploaderModal locationId={locationId} />
      <FilePreviewModal />
    </>
  );
}

export default AttachedFilesBlock;

const CloudPath = ({ data }) => {
  const status = data?.cloudStatus;
  if (status == "Pending" || status == "null") return <div>Pending</div>;
  if (status == "Failed") return <div>Failed</div>;

  if (status == "Uploaded" || status == "Downloaded")
    return (
      <a href={data?.cloudPath} target="_blank" rel="noreferrer">
        <SlCloudDownload
          style={{ height: "25px", width: "25px", paddingTop: "4px" }}
        />
      </a>
    );
};

const File = ({ inputsStatus, fileData, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const { showFilePreview } = useFilePreviewModal();
  const data = fileData;

  // File is previewable once it's available in cloud storage. Use the cloud
  // URL (same link the download icon opens) and the title as the display name.
  const cloudReady =
    data?.cloudStatus == "Uploaded" || data?.cloudStatus == "Downloaded";
  const previewUrl = cloudReady ? data?.cloudPath : null;
  const openPreview = () => {
    if (previewUrl) showFilePreview({ name: data?.fileTitle, url: previewUrl });
  };
  const localPath = (
    <a href={data?.localPath} target="_blank">
      <LiaFileDownloadSolid style={{ height: "25px", width: "25px" }} />
    </a>
  );
  // const cloudPath = (
  // 	<a href={data?.cloudPath} target='_blank'>
  // 		<SlCloudDownload style={{ height: '25px', width: '25px', paddingTop: '4px' }} />
  // 	</a>
  // );
  let ts = new Date(data?.createdAt);
  let timeC = moment(ts).format("YYYY-MM-DD HH:mm");
  const fileTitle = data?.fileTitle || "";
  const truncatedTitle =
    fileTitle.length > 40 ? `${fileTitle.slice(0, 40)}...` : fileTitle;
  let logMessage = <>No logs available</>;
  if (data?.actionLogs?.length) {
    logMessage = (
      <>
        {data.actionLogs.map((log, index) => (
          <p key={index}>
            {formatLogTime(log.time)} {log.user}: {log.actionName}
          </p>
        ))}
      </>
    );
  }
  return (
    <>
      <div className={styles.attached_file_container} key={data?._id}>
        <div className={styles.small}>
          <AttachmentIcon
            style={{ height: "18px", width: "25px", paddingBottom: "2px" }}
          />

          <Whisper
            placement="top"
            controlId="fileTitle"
            trigger="hover"
            speaker={
              <Popover>
                <>{previewUrl ? "Click to preview" : data?.fileTitle}</>
              </Popover>
            }
          >
            <span
              className={previewUrl ? styles.previewable_title : undefined}
              onClick={openPreview}
              role={previewUrl ? "button" : undefined}
              tabIndex={previewUrl ? 0 : undefined}
            >
              {truncatedTitle}
            </span>
          </Whisper>

          
        </div>

        <div className={styles.small}> {timeC} </div>

        <div className={styles.clocal}>
          <span>
            {data?.localStatus == "Downloaded" ? "Downloaded" : "---"}
          </span>
        </div>
        <div className={styles.cloud}>
          <Whisper
            placement="top"
            controlId="cloudPath"
            trigger="hover"
            speaker={<Popover>Download file from cloud storage</Popover>}
          >
            <CloudPath data={data} />
          </Whisper>
        </div>
        <div className={styles.origin}>{data.origin}</div>
        <div className={styles.logs}>
          <Whisper
            placement="top"
            trigger="hover"
            controlId="control-id-hover"
            speaker={<Popover title="File logs">{logMessage}</Popover>}
          >
            <span>
              <RiMessage2Line
                style={{ height: "20px", width: "20px", marginTop: "6px" }}
              />
            </span>
          </Whisper>
        </div>
        {inputsStatus == "edit" && (
          <div style={{ height: "23px", width: "23px", paddingTop: "1px" }}>
            <DeleteIcon onClick={onDelete} />
          </div>
        )}
      </div>
    </>
  );
};

export const DeleteIcon = ({ onClick }) => {
  return (
    <>
      <svg
        onClick={onClick}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M15 5L5 15"
          stroke="#EF4B4B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 5L5 15"
          stroke="#EF4B4B"
          strokeOpacity="0.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 5L15 15"
          stroke="#EF4B4B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 5L15 15"
          stroke="#EF4B4B"
          strokeOpacity="0.5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
